<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}
body,#app{
  	height: 100%;
  }
*{
		margin: 0;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue